import { FilterHandler } from 'app/shared/filter-handler';
import { Model } from './model';
import { Entity } from './entity';
import { Ship } from './ship';
import { Profile } from './profile';

export class SalesPurchases extends Model {
  expanded: boolean;

  constructor(values: Object = {}) {
    super(values);
    this.expanded = false;
  }

  public apiMap(values: Object = {}) {
    return new SalesPurchases(values);
  }
}

export class SalesPurchasesFilter extends FilterHandler {
  start_date = '';
  end_date = '';
  buyer_entity: Entity[] = [];
  seller_entity: Entity[] = [];
  ship: Ship[] = [];

  constructor(values: Object = {}) {
    super();
    const today = new Date();
    this.buyer_entity = [];
    this.seller_entity = [];
    this.ship = [];
    this.start_date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    this.end_date = '';

    this.unSerializedRouterParams(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/sales-purchases.ts